import request from '@/utils/request'

// 全局类型接口，多个参数传数组，单个参数传字符串
export async function api_getConfig(name) {
  let params = ''
  if (name instanceof Array) {
    name.forEach((item, index) => {
      if (index !== 0) {
        params = params + '&name=' + item
      } else {
        params = '?name=' + item
      }
    })
  } else {
    params = '?name=' + name
  }
  return request({
    url: `/rest/config${params}`,
    method: 'get',
    params: {},
  })
}

// 上传图片统一接口
export async function api_postFileUpload(file, type='') {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)
  return request({
    url: '/rest/storage',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })
}

// 获取积分类型
export async function api_getPointType(params) {
  return request({
    url: '/rest/member/point/type',
    method: 'get',
    params,
  })
}
// 获取会员权益列表--不分页
export async function api_getListBenefit(params) {
  return request({
    url: '/rest/member/config/listBenefit',
    method: 'get',
    params,
  })
}
// 获取会员等级--不分页
export async function api_getListLevelNoPage(params) {
  return request({
    url: '/rest/member/config/listLevel',
    method: 'get',
    params,
  })
}
// 获取会员标签--不分页
export async function api_getListLabel(params) {
  return request({
    url: '/rest/member/config/listLabel',
    method: 'get',
    params,
  })
}
// 获取会员画像--不分页
export async function api_getListPortrait(params) {
  return request({
    url: '/rest/member/config/portrait/list',
    method: 'get',
    params,
  })
}
// 获取可用优惠券列表--不分页
export async function api_getListCoupon(params) {
  return request({
    url: '/rest/market/coupon/template/available/list',
    method: 'get',
    params,
  })
}
// 获取可用优惠券列表--不分页（无中台券）
export async function api_getListRTCoupon(params) {
  return request({
    url: '/rest/market/coupon/template/nonestock/available/list',
    method: 'get',
    params,
  })
}
// 获取可用礼品券列表--不分页
export async function api_getGiftListCoupon(params) {
  return request({
    url: '/rest/market/coupon/gift/template/available/list',
    method: 'get',
    params,
  })
}
// 获取可用抵扣券列表--不分页
export async function api_getSkuCouponList(params) {
  return request({
    url: '/rest/market/deduct/coupon/template/available/list',
    method: 'get',
    params,
  })
}
// 打标签
export async function api_getLabeled(data) {
  return request({
    url: '/rest/member/labeled',
    method: 'post',
    data,
  })
}

// 通过userId或memberId获取手机号
export async function api_getUserPhone(params) {
  return request({
    url: '/rest/phone/user',
    method: 'get',
    params,
  })
}

// 发送短信
export async function api_getSendCode(params) {
  return request({
    url: '/rest/finance/store/sendCode',
    method: 'get',
    params,
  })
}

// 校验短信验证码
export async function api_getVerifyCode(params) {
  return request({
    url: '/rest/finance/store/verify',
    method: 'get',
    params,
  })
}

// 获取会员数量
export async function api_getMemberCount(params) {
  return request({
    url: '/rest/member/count',
    method: 'get',
    params,
  })
}
